import { Application } from './Application';
import { ApplicationsErrorCode, createApplicationsError, } from './ApplicationsError';
import { PlatformPrivateEvent, } from '@wix/public-editor-platform-events';
export class Applications {
    constructor(events) {
        this.events = events;
        this.applications = {};
        this.subscribeOnPrivateEvents(events);
    }
    subscribeOnPrivateEvents(events) {
        events.subscribe((event) => {
            switch (event.type) {
                case PlatformPrivateEvent.ApplicationsSpecsReceived:
                    for (const appDefinitionId of event.payload.appDefinitionIds) {
                        this.init(appDefinitionId);
                    }
                    break;
            }
        });
    }
    init(appDefinitionId) {
        this.applications[appDefinitionId] = new Application(appDefinitionId);
    }
    async setApplication(app) {
        await this.events?.withEvent(this.events.factories.createInitApplicationApiEvent(app.appDefinitionId), () => {
            if (!this.applications[app.appDefinitionId]) {
                this.init(app.appDefinitionId);
            }
            this.applications[app.appDefinitionId].setApplication(app);
        });
    }
    ensureApplication(appDefinitionId) {
        const app = this.applications[appDefinitionId];
        if (!app) {
            throw createApplicationsError(ApplicationsErrorCode.ApplicationDoesNotExist).withApplicationId(appDefinitionId);
        }
        return app;
    }
    /**
     * NOTE: called only at the WorkerManager
     * when iframe is connected to the infra
     */
    async getPrivateAPI(appDefinitionId) {
        return this.events?.withEvent(this.events.factories.createGetApplicationApiEvent(appDefinitionId, 'private'), async () => {
            const app = this.ensureApplication(appDefinitionId);
            return app.getPrivateAPI();
        });
    }
    /**
     * NOTE: called from private api namespace
     */
    async getPublicAPIWhenAppIsReady(appDefinitionId) {
        return this.events?.withEvent(this.events.factories.createGetApplicationApiEvent(appDefinitionId, 'public'), async () => {
            const app = await this.ensureApplication(appDefinitionId).waitReady();
            return app.getPublicAPI();
        });
    }
}
//# sourceMappingURL=Applications.js.map